import React, { useEffect, useState } from 'react'
import { Button, Col, Modal, Form, notification, Row, Typography, Card } from 'antd'
import { useDispatch } from 'react-redux'
import { RightOutlined } from '@ant-design/icons'

const { Title, Text } = Typography;

const PlanDetailsModal = (props) => {
    let dispatch = useDispatch()
    let { visible, onClose, packageData, onSubmit } = props


    console.log(packageData, "package------------------------")

    return (
        <>
            <Modal
                visible={visible}
                onCancel={onClose}
                title={`Plan Details`}
                width={'70%'}
                footer={null}
                bodyStyle={{ padding: 0 }}
                style={{ top: 20 }}>

                {packageData && (
                    <div style={{ background: 'linear-gradient(135deg, #e6e6fa 0%, #f0f8ff 100%)', borderRadius: '8px' }}>
                        {/* Modal Content */}
                        <div style={{ padding: '32px' }}>
                            <Row gutter={[32, 32]}>
                                {/* Left Column - Plan Details */}
                                <Col xs={24} md={12}>
                                    <div style={{ background: 'white', borderRadius: '16px', padding: '24px' }}>
                                        <Title level={3} style={{ color: '#333', marginBottom: '24px' }}>
                                            Plan Details
                                        </Title>

                                        {/* Package Header */}
                                        <div style={{ marginBottom: '24px' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>

                                                <div>
                                                    <Title level={4} style={{ margin: 0, color: '#214E9E' }}>
                                                        {packageData.data}GB
                                                    </Title>
                                                </div>
                                            </div>
                                            <Text style={{ color: '#214E9E', display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
                                                {packageData.plan_type || 'Data Only'}
                                            </Text>
                                            <Text style={{ color: '#666' }}>
                                                {packageData.day || packageData.validity} Days
                                            </Text>
                                        </div>

                                        {/* Details Grid */}
                                        <div style={{ marginBottom: '24px' }}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '12px 0',
                                                borderBottom: '1px solid #f0f0f0'
                                            }}>
                                                <Text style={{ fontWeight: 'bold' }}>Validity</Text>
                                                <Text>{packageData.day || packageData.validity} Days</Text>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '12px 0',
                                                borderBottom: '1px solid #f0f0f0'
                                            }}>
                                                <Text style={{ fontWeight: 'bold' }}>Data Amount</Text>
                                                <Text>{packageData.data} GB</Text>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '12px 0',
                                                borderBottom: '1px solid #f0f0f0'
                                            }}>
                                                <Text style={{ fontWeight: 'bold' }}>Calls & Texts</Text>
                                                <Text>
                                                    {packageData.calls === 'Unlimited' || packageData.text === 'Unlimited'
                                                        ? 'Yes'
                                                        : packageData.calls || 'No'}
                                                </Text>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '12px 0',
                                                borderBottom: '1px solid #f0f0f0'
                                            }}>
                                                <Text style={{ fontWeight: 'bold' }}>Coverage</Text>
                                                {packageData.name}
                                            </div>
                                        </div>

                                        {/* Activation Section */}
                                        <div>
                                            <Title level={5} style={{ color: '#333', marginBottom: '12px' }}>
                                                Activation
                                            </Title>
                                            <Text style={{ color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
                                                Upon purchasing a plan, you'll get a QR code. Scan it for instant
                                                eSIM installation or save it for later use. Your plan activates upon
                                                installation and connection to your destination.
                                            </Text>
                                        </div>
                                    </div>
                                </Col>

                                {/* Right Column - Additional Details */}
                                <Col xs={24} md={12}>
                                    <div style={{ background: 'white', borderRadius: '16px', padding: '24px' }}>
                                        <Title level={3} style={{ color: '#333', marginBottom: '24px' }}>
                                            Additional Details
                                        </Title>

                                        <div style={{ marginBottom: '24px' }}>
                                            {/*<div style={{*/}
                                            {/*    display: 'flex',*/}
                                            {/*    justifyContent: 'space-between',*/}
                                            {/*    alignItems: 'center',*/}
                                            {/*    padding: '16px 0',*/}
                                            {/*    borderBottom: '1px solid #f0f0f0'*/}
                                            {/*}}>*/}
                                            {/*    <div>*/}
                                            {/*        <Text style={{ fontWeight: 'bold', display: 'block' }}>Network</Text>*/}
                                            {/*        <Text style={{ color: '#666', fontSize: '14px' }}>*/}
                                            {/*            {packageData.first_network}*/}
                                            {/*        </Text>*/}
                                            {/*    </div>*/}

                                            {/*</div>*/}

                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '16px 0',
                                                borderBottom: '1px solid #f0f0f0'
                                            }}>
                                                <Text style={{ fontWeight: 'bold' }}>Network</Text>
                                                <Text>{packageData.first_network || packageData.network || 'Local Network'}</Text>
                                            </div>

                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '16px 0',
                                                borderBottom: '1px solid #f0f0f0'
                                            }}>
                                                <Text style={{ fontWeight: 'bold' }}>Plan type</Text>
                                                <Text>Local</Text>
                                            </div>

                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                padding: '16px 0'
                                            }}>
                                                <Text style={{ fontWeight: 'bold' }}>Speed</Text>
                                                <Text>{packageData.speed || '4G'}</Text>
                                            </div>

                                            {/* Additional package info if available */}
                                            {packageData.product_code && (
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '16px 0',
                                                    borderTop: '1px solid #f0f0f0'
                                                }}>
                                                    <Text style={{ fontWeight: 'bold' }}>Product Code</Text>
                                                    <Text>{packageData.product_code}</Text>
                                                </div>
                                            )}

                                            {packageData.package_id && (
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '16px 0'
                                                }}>
                                                    <Text style={{ fontWeight: 'bold' }}>Package ID</Text>
                                                    <Text style={{ fontSize: '12px', color: '#666' }}>
                                                        {packageData.package_id}
                                                    </Text>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>


                        <div style={{
                            background: 'white',
                            padding: '24px 32px',
                            borderTop: '1px solid #f0f0f0',
                            borderBottomLeftRadius: '8px',
                            borderBottomRightRadius: '8px'
                        }}>
                            <Row span={24}>
                                <Col span={21}>
                                    <Title level={2} style={{
                                        margin: 0,
                                        color: '#333',
                                        fontSize: '32px'
                                    }}>
                                        £{packageData.amount}
                                    </Title>
                                </Col>
                                <Col span={3}>
                                    <Button
                                        type="btn btn-primary"
                                        size="large"
                                        onClick={onSubmit}

                                    >
                                        Buy Now
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                )}
            </Modal>
        </>
    )
}

export default PlanDetailsModal